import cx from 'classnames';
import { ReactComponent as CheckIcon } from 'new/components/icons/fi-rr-check.svg';
import { ReactComponent as UndoIcon } from 'new/components/icons/fi-rr-undo.svg';
import { Button } from 'new/elements/Button';
import React, { FC } from 'react';

import s from './UpdateModeHeader.module.scss';

type Props = {
  title: string;
  isModified?: boolean;
  disableOnUpdateBtn?: boolean;
  showUpdateButton?: boolean;
  onCancelClick(): void;
  onUpdateClick(): void;
};

export const UpdateModeHeader: FC<Props> = ({
  title,
  onCancelClick,
  onUpdateClick,
  isModified = false,
  disableOnUpdateBtn = false,
  showUpdateButton = true,
}) => {
  const actionClassname = isModified
    ? cx(s.actions, s.actionsSpaceBetween)
    : cx(s.actions, s.actionsFlexEnd);

  return (
    <div className={s.container}>
      {!isModified && <div className={s.title}>{title}</div>}
      <div className={actionClassname}>
        <Button variant="ghost" onClick={onCancelClick}>
          {isModified ? (
            <>
              <UndoIcon />
              Discard Changes
            </>
          ) : (
            'Cancel'
          )}
        </Button>
        {isModified && showUpdateButton && (
          <Button
            color="primary"
            variant="contained"
            onClick={onUpdateClick}
            disabled={disableOnUpdateBtn}
          >
            <CheckIcon className="icon" />
            Update Cache
          </Button>
        )}
      </div>
    </div>
  );
};
